import React from 'react';
import './ErrorMessage.module.css';

interface ErrorMessageProps {
  message: string;
  onDismiss?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onDismiss }) => {
  if (!message) return null;

  return (
    <div className="error-message">
      <div className="error-content">
        <span className="error-icon">⚠</span>
        <span className="error-text">{message}</span>
      </div>
      {onDismiss && (
        <button onClick={onDismiss} className="error-dismiss" aria-label="Dismiss error">
          &times;
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
